/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const ADD_CLIENT_SECRET_TITLE = 'Add Client Secret';
export const CLIENT_SECRET_TITLE = 'Client Secret';
export const EXPIRES_IN_LABEL = 'Expires in';
export const SECRET_NAME = "Secret Name";
export const CLIENT_SECRET_CREATE_SUCCESS_MESSAGE = 'Client Secret created successfully';
export const CLIENT_SECRET_CREATE_FAILURE_MESSAGE = 'Error in creating client secret: {0}';
export const BUTTON_ADD_CLIENT_SECRET = 'Add Client Secret';
export const BUTTON_CANCEL = 'Cancel';
export const BUTTON_CLOSE = 'Close';
export const CREATE_CLIENT_SECRET_BTN = 'createClientSecretBtn';

export const PERIOD_OPTIONS_LIST = [
  { value: 1, label: "Days" },
  { value: 7, label: "Weeks" },
  { value: 30, label: "Months" }
];

export const VALIDATION_MESSAGES = {
  VALUE_REQUIRED: 'Value is required',
  VALUE_BIGGER_THAN_ZERO: 'Value must be bigger than 0',
  MAXIMUM_DAYS_ALLOWED: 'Maximum {0} days allowed',
  MACHINE_SECRET_NAME_REQUIRED: 'Machine secret name is required for generating client secret',
};
